<template>
    <b-modal id="modal-relatorio-gestao" v-model="vis" :title="titulo" size="lg" centered scrollable body-class="p-0"
        hide-header hide-footer @hidden="$emit('fecharModal')">
        <relatorio-gestao :titulo="titulo" :gerarRelatorio="gerarRelatorio" :loading="loading" :pdfData="pdfData" modal
            @fecharModal="$emit('fecharModal')">
            <slot></slot>
        </relatorio-gestao>
    </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import RelatorioGestao from './RelatorioGestao.vue'

const CompProps = Vue.extend({
    name: 'ModalRelatorioGestao',
    components: { RelatorioGestao },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: 'Relatório'
        },
        gerarRelatorio: {
            type: Function,
            required: true
        },
        pdfData: {
            type: String,
            default: ''
        },
    }
})

@Component
export default class ModalRelatorioGestao extends CompProps {
    vis = true
}
</script>